import { render, staticRenderFns } from "./ProhibitedWords.vue?vue&type=template&id=0c94c024&"
import script from "./ProhibitedWords.vue?vue&type=script&lang=js&"
export * from "./ProhibitedWords.vue?vue&type=script&lang=js&"
import style0 from "./ProhibitedWords.vue?vue&type=style&index=0&id=0c94c024&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports